import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { BehaviorSubject } from 'rxjs';
import * as _ from "lodash";
import * as moment from 'moment';
import { CommonAPIService } from 'app/utils/services/common-api.service';


@Injectable({
    providedIn: 'root'
})
export class OrderService {
    calculateTotalGarmentOnRemoveAddress: BehaviorSubject<any> = new BehaviorSubject(null);
    assignSplitAddressesOnGarment: BehaviorSubject<any> = new BehaviorSubject(null);
    selectedOldProductValue: BehaviorSubject<any> = new BehaviorSubject(null);
    setNewProductValues: BehaviorSubject<any> = new BehaviorSubject(null);
    callAssignGarmentInSplitAddresses: BehaviorSubject<any> = new BehaviorSubject(null);
    artworkLocationKeysList: BehaviorSubject<any> = new BehaviorSubject(null);
    setLineItemsWithMarkup: BehaviorSubject<any> = new BehaviorSubject(null);

    states = [
        { "value": 'AL', "label": 'Alabama' },
        { "value": 'AK', "label": 'Alaska' },
        { "value": 'AS', "label": 'American Samoa' },
        { "value": 'AZ', "label": 'Arizona' },
        { "value": 'AR', "label": 'Arkansas' },
        { "value": 'CA', "label": 'California' },
        { "value": 'CO', "label": 'Colorado' },
        { "value": 'CT', "label": 'Connecticut' },
        { "value": 'DE', "label": 'Delaware' },
        { "value": 'DC', "label": 'District of Colombia' },
        { "value": 'FM', "label": 'Federated States of Micronesia' },
        { "value": 'FL', "label": 'Florida' },
        { "value": 'GA', "label": 'Georgia' },
        { "value": 'GU', "label": 'Guam' },
        { "value": 'HI', "label": 'Hawaii' },
        { "value": 'ID', "label": 'Idaho' },
        { "value": 'IL', "label": 'Illinois' },
        { "value": 'IN', "label": 'Indiana' },
        { "value": 'IA', "label": 'Iowa' },
        { "value": 'KS', "label": 'Kansas' },
        { "value": 'KY', "label": 'Kentucky' },
        { "value": 'LA', "label": 'Louisiana' },
        { "value": 'ME', "label": 'Maine' },
        { "value": 'MH', "label": 'Marshall Islands' },
        { "value": 'MD', "label": 'Maryland' },
        { "value": 'MA', "label": 'Massachusetts' },
        { "value": 'MI', "label": 'Michigan' },
        { "value": 'MN', "label": 'Minnesota' },
        { "value": 'MS', "label": 'Mississippi' },
        { "value": 'MO', "label": 'Missouri' },
        { "value": 'MT', "label": 'Montana' },
        { "value": 'NE', "label": 'Nebraska' },
        { "value": 'NV', "label": 'Nevada' },
        { "value": 'NH', "label": 'New Hampshire' },
        { "value": 'NJ', "label": 'New Jersey' },
        { "value": 'NM', "label": 'New Mexico' },
        { "value": 'NY', "label": 'New York' },
        { "value": 'NC', "label": 'North Carolina' },
        { "value": 'ND', "label": 'North Dakota' },
        { "value": 'MP', "label": 'Northern Mariana Islands' },
        { "value": 'OH', "label": 'Ohio' },
        { "value": 'OK', "label": 'Oklahoma' },
        { "value": 'OR', "label": 'Oregon' },
        { "value": 'PW', "label": 'Palau' },
        { "value": 'PA', "label": 'Pennsylvania' },
        { "value": 'PR', "label": 'Puerto Rico' },
        { "value": 'RI', "label": 'Rhode Island' },
        { "value": 'SC', "label": 'South Carolina' },
        { "value": 'SD', "label": 'South Dakota' },
        { "value": 'TN', "label": 'Tennessee' },
        { "value": 'TX', "label": 'Texas' },
        { "value": 'UT', "label": 'Utah' },
        { "value": 'VT', "label": 'Vermont' },
        { "value": 'VI', "label": 'Virgin Islands' },
        { "value": 'VA', "label": 'Virginia' },
        { "value": 'WA', "label": 'Washington' },
        { "value": 'WV', "label": 'West Virginia' },
        { "value": 'WI', "label": 'Wisconsin' },
        { "value": 'WY', "label": 'Wyoming' }
    ];

    countries = [
        { "value": 'US', "label": 'United States' }
    ];

    constructor(
        private db: AngularFireDatabase,
        private commonAPIService: CommonAPIService
    ) { }

    /**
    * get orders without page limit
    * 
    * @returns Array
    */
    getAllOrder() {
        return this.db.list('/orders').snapshotChanges();
    }

    createSplitAddressesObjOnEachGarment(order) {
        if (order?.shirts && order?.shirts?.length) {
            order?.shirts.forEach((element, i) => {
                if (element && element.product_id && element.color && element.color.color_id) {
                    order?.splitAddresses.forEach((item, j) => {
                        if (order?.shirts[i]?.hasOwnProperty('splitAddresses') && order?.shirts[i]?.splitAddresses?.length < order?.splitAddresses?.length) {
                            order.shirts[i].splitAddresses.push({ addressIndex: order?.shirts[i]?.splitAddresses?.length + 1, isDisplay: false, productId: element?.product_id, colorId: element?.color?.color_id, quantities: {}, firstName: element.firstName, lastName: element.lastName, email: element.email, address1: element.address1, address2: element.address2, method: element.method, city: element.city, state: element.state, zip: element.zip });
                        } else {
                            if (!order.shirts[i].hasOwnProperty('splitAddresses')) {
                                order.shirts[i].splitAddresses = [{ addressIndex: j + 1, isDisplay: false, productId: element?.product_id, colorId: element?.color.color_id, quantities: {} }];
                            } else if (order?.shirts[i]?.splitAddresses?.length == order?.splitAddresses?.length) {
                                let mappingOrder = this.mappingShirtsAndSplitAddresses(order);
                                order = mappingOrder;
                            }
                        }
                        order.shirts[i].splitAddresses = this.getUniqueItems(order?.shirts[i].splitAddresses);
                        this.countTotalQtyOfProduct(order);
                    });
                } 
            });
        }
        this.assignSplitAddressesOnGarment.next(true);
        return order;
    }

    addDeliveryDaysIndividualShipping(date) {
        date = moment(date);
        date = date.add(2, 'days');
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
    }

    getUniqueItems(items) {
        const uniqueIds = new Set(items.map((item) => item.addressIndex))
      
        const itemsWithUniqueIds = [...uniqueIds].map(id => items.find(item => item.addressIndex === id)).filter(Boolean)
      
        return itemsWithUniqueIds
    }

    mappingShirtsAndSplitAddresses(order) {
        order.shirts.forEach((element, i) => {
            order.splitAddresses.forEach((item, j) => {
                let garment = item?.shirts && item?.shirts[i];
                let address = element?.splitAddresses && element?.splitAddresses[j];
                if (garment && address && (garment.addressIndex == address.addressIndex) && (garment.productId == address.productId) && (garment.colorId == address.colorId)) {
                    garment.quantities = address.quantities;
                    garment.totalQuantity = address.totalQuantity;
                }
            });
        });

        order?.shirts?.forEach((shirt, i) => {
            shirt?.splitAddresses?.forEach((address, j) => {
                if (address) {
                    let obj: any = {};
                    obj['addressIndex'] = address.addressIndex;
                    obj['quantities'] = address.quantities;
                    obj['productId'] = address.productId;
                    obj['colorId'] = address.colorId;
                    obj['totalQuantity'] = address.totalQuantity;
                    if (!order?.splitAddresses[j]?.hasOwnProperty('shirts')) {
                        order.splitAddresses[j].shirts = [];
                        order?.splitAddresses[j]?.shirts?.push(obj);
                    } else {
                        if (!order?.splitAddresses[j]?.shirts.length) {
                            order?.splitAddresses[j]?.shirts?.push(obj);
                        } else { }
                    }
                }
            });
            order?.splitAddresses[i]?.shirts?.sort((a,b) => a.addressIndex - b.addressIndex);
        });

        let shirtTotalQty = 0;
        let shirtTotalQtyOnEachSplitAddress = 0;
        if (order.shirts && order.shirts.length) {
            order.shirts.forEach((shirt, i) => {
                if (order.splitAddresses && order.splitAddresses.length) {
                    order.splitAddresses.forEach((address, j) => {
                        if (address.shirts && address.shirts.length) {
                            address.shirts.forEach((product, k) => {
                                if (shirt.product_id == product.productId && (shirt.color && shirt.color.color_id == product.colorId)) {
                                    shirtTotalQty = shirt.totalQty;
                                    shirtTotalQtyOnEachSplitAddress += product.totalQuantity;
                                }
                            });
                        }
                    });
                    if (shirtTotalQty != shirtTotalQtyOnEachSplitAddress) {
                        order.splitAddresses.forEach((addressOne, m) => {
                            if (addressOne.shirts && addressOne.shirts.length) {
                                addressOne.shirts.forEach((productOne, n) => {
                                    if (shirt.product_id == productOne.productId && (shirt.color && shirt.color.color_id == productOne.colorId) && m == 0) {
                                        productOne.quantities = shirt.quantities;
                                        productOne.totalQuantity = shirt.totalQty;
                                    }
                                });
                            }
                        });
                    }
                }
            });
        }
        return order;
    }

    getTotalQuantityByItem(productsQty) {
        return Object.values(productsQty).reduce((a, b) => Number(a) + Number(b), 0);
    }

    getTotalQuantityOnEachSplitAddresses(products) {
        let allQuantities = [];
        if (products && products.length) {
            products.forEach(element => {
                for(let key in element.quantities) {
                    if(element.quantities.hasOwnProperty(key)) {
                        let value = element.quantities[key];
                        allQuantities.push(value);
                    }
                } 
            });
            return allQuantities.reduce((a, b) => Number(a) + Number(b), 0);
        }
    }

    padStarting(number, size) {
        number = number.toString();
        while (number.length < size) number = "0" + number;
        return number;
    }

    countTotalQtyOfProduct(order) {
        let sumValues: any = 0;
        if (order && order.shirts && order.shirts.length) {
            order.shirts.forEach((product, i) => {
                if (product && product.quantities) {
                    sumValues = Object.values(product.quantities).reduce((a, b) => Number(a) + Number(b), 0);
                }
                product.totalQty = sumValues;
           });
        }
    }

    isSameUser = (a, b) => a.addressIndex === b.addressIndex && a.productId === b.productId && a.colorId == b.colorId;

    onlyInLeft = (left, right, compareFunction) => left.filter(leftValue => !right.some(rightValue => compareFunction(leftValue, rightValue)));

    getSubStatuses(data, status) {
        return data?.find((x) => x?.status?.toLowerCase() == status?.toLowerCase())?.substatuses;
    }

    getSubStatusValue(data, status, substatus) {
        let substatuses = data?.find((x) => x?.status?.toLowerCase() == status?.toLowerCase())?.substatuses;
        return substatuses?.find((x) => x?.substatus?.toLowerCase() == substatus?.toLowerCase())?.value;
    }

    fetchAvailableSizes(order) {
        let availableSizes = [];
        order.shirts.forEach((shirt) => {
            const colorName = shirt.colorName;
            for (let color of shirt?.style?.colors) {
                if (color && color.length && color[0].colorName === colorName) {
                    color.forEach((item) => {
                        const obj = {
                            sizeName: item.sizeName,
                            sizeId: item.size_id
                        };
                        if (!availableSizes.some((item) => item.sizeId === obj.sizeId)) {
                            availableSizes.push(obj);
                        }                        
                    });
                }
            }
            availableSizes = _.orderBy(availableSizes, ['sizeId']);
        });
        return availableSizes || [];
    }

    isAddressIndividualShipping(order) {
        let shipMethods = [];
        if (order && order.splitAddresses && order.splitAddresses.length) {
            order.splitAddresses.forEach(element => {
              if (element && element.method) {
                shipMethods.push(element.method);
              }
            });
        }
        if (shipMethods && shipMethods.length) {
            return shipMethods.includes(this.commonAPIService.INDIVIDUAL_SHIPPING);
        } else {
            return false;
        }
    }

}
